import React from "react";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "~/components/ui/dialog";
import AddressForm, {
  AddressFormValues,
} from "~/pages/clients/components/client-detail/address/form/AddressForm";

interface AddressDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description: string;
  onSubmit: (values: AddressFormValues) => void;
  defaultValues?: AddressFormValues;
  selectedRegion: string;
  setSelectedRegion: (region: string) => void;
  selectedComuna: string;
  setSelectedComuna: (comuna: string) => void;
  availableComunas: { id: string; name: string }[];
  isEdit?: boolean;
}

const AddressDialog: React.FC<AddressDialogProps> = ({
  isOpen,
  onOpenChange,
  title,
  description,
  onSubmit,
  defaultValues,
  selectedRegion,
  setSelectedRegion,
  selectedComuna,
  setSelectedComuna,
  availableComunas,
  isEdit = false,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[550px]">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <AddressForm
          defaultValues={defaultValues}
          onSubmit={onSubmit}
          selectedRegion={selectedRegion}
          setSelectedRegion={setSelectedRegion}
          selectedComuna={selectedComuna}
          setSelectedComuna={setSelectedComuna}
          availableComunas={availableComunas}
          isEdit={isEdit}
        />
      </DialogContent>
    </Dialog>
  );
};

export default AddressDialog;
